export const STEP_SETUP = 'setup';
export const STEP_RECIPIENTS_TYPE = 'recipients_list';
export const STEP_RECIPIENTS_AUTO = 'recipients_auto';
export const STEP_RECIPIENTS_MANUAL = 'recipients_manual';
export const STEP_TEMPLATE_LIST = 'template_list';
export const STEP_TEMPLATE_EDITOR = 'template_editor';
export const STEP_REVIEW = 'review';
